import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { artavaBrand, getArtavaCopy } from '../../branding/artavaBrand';
import styles from './ArtavaAttribution.module.css';

export default function ArtavaAttribution({
  to = '/support/artava',
  variant = 'footer',
  detail = true,
}) {
  const { i18n } = useTranslation();
  const copy = getArtavaCopy(i18n.language?.startsWith('it'));
  const compact = variant === 'compact';

  return (
    <Link
      to={to}
      className={`${styles.link} ${compact ? styles.linkCompact : ''}`}
      aria-label={`${copy.attribution}. ${copy.supportTitle}.`}
    >
      <span className={styles.overline}>{artavaBrand.footerAttribution}</span>
      <strong className={styles.title}>{copy.attribution}</strong>
      {detail ? <span className={styles.detail}>{copy.attributionDetail}</span> : null}
    </Link>
  );
}
